module.exports = __webpack_public_path__ + "static/media/pasta_770_gr.159872a4.png";